import QRcode from "v-qrcode/src/index.vue";
import VueHtml2pdf from 'vue-html2pdf';
import html2canvas from "html2canvas";
export default {
  name: "maintenanceQRCodeDlg",
  components: {
    QRcode,
    VueHtml2pdf
  },
  data() {
    return {
      dialog: false,
      isQRCodeLoading: false,
      qrCodeScreenshot: null
    }
  },
  computed: {
    facility() {
      return this.$store.state.authModule.currentFacilityData;
    },
    qrCode() {
      return `https://${this.facility.baseUrl}/maintenanceCreateRequest?facilityId=${this.facility.id}`;
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    printQRCode() {
      this.isQRCodeLoading = true;

      setTimeout(async () => {
        const canvas = await html2canvas(document.querySelector('#maintenance-qr-code'));
        const url = canvas.toDataURL();

        this.qrCodeScreenshot = url;

        await this.$refs.html2Pdf.generatePdf();
        this.isQRCodeLoading = false;
      }, 200);
    }
  }
}